import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import HttpApi from 'i18next-http-backend';
import { SessionStorageWrapper } from '../utils/SessionStorageWrapper';
import { HTTP_HEADERS } from '../constants/api';
import {
  DEFAULT_LANGUAGE,
  DEFAULT_LOCIZE_NAMESPACE,
  DEFAULT_LOCIZE_VERSION,
  NAMESPACE_SEPARATOR,
  TRANSLATION_LOAD_PATH,
  KEY_SEPARATOR,
  SERVICE_NAME,
} from '../constants';

const version = process.env.REACT_APP_LOCIZE_VERSION || DEFAULT_LOCIZE_VERSION;
const debug = process.env.REACT_APP_LOCIZE_DEBUG === 'true';

let localization = null;

const LOCAL_STORAGE_EXPIRATION_TIME = 3600000;

const callback = (error) => {
  error && console.error(error);
};

export const initLocalization = async ({
  lang = DEFAULT_LANGUAGE,
  proxyPrefix = '',
  operatorId = '',
  brand = '',
}) => {
  const getStorageKey = (key) =>
    [
      'i18next',
      'casino',
      SERVICE_NAME,
      version,
      key,
      ...(operatorId ? [operatorId] : ['empty_operator']),
      ...(brand ? [brand] : ['empty_brand']),
    ].join('_');

  if (typeof lang !== 'string')
    throw new Error('i18next: correct lang param is not provided.');

  const i18Instance = i18next.createInstance();

  const getOptions = () => {
    return {
      debug,
      version,
      compatibilityJSON: 'v3',
      ns: DEFAULT_LOCIZE_NAMESPACE,
      defaultNS: DEFAULT_LOCIZE_NAMESPACE,
      lng: lang,
      keySeparator: KEY_SEPARATOR,
      nsSeparator: NAMESPACE_SEPARATOR,
      fallbackLng: false,
      fallbackNS: DEFAULT_LOCIZE_NAMESPACE,
      load: 'currentOnly',
      saveMissing: false, // call save missing key if key not found, disabled
      saveMissingPlurals: false, // same if t was called for plurals, disabled
      interpolation: {
        escapeValue: false, // react already safes from xss, so need to disable
      },
      postProcess: [],
      backend: {
        backends: [LocalStorageBackend, HttpApi],
        backendOptions: [
          {
            prefix: '',
            // 1 hour expiration from session storage
            expirationTime: LOCAL_STORAGE_EXPIRATION_TIME,
            // Session storage has more memory
            store: new SessionStorageWrapper(getStorageKey),
          },
          {
            loadPath: `${proxyPrefix}${TRANSLATION_LOAD_PATH}`,
            allowMultiLoading: false,
            customHeaders: () => ({
              [HTTP_HEADERS.BRAND]: brand,
              [HTTP_HEADERS.OPERATOR_ID]: operatorId,
            }),
          },
        ],
      },
    };
  };

  localization = {
    instance: i18Instance,
    init() {
      return i18Instance.use(ChainedBackend).init(getOptions(), callback);
    },
    // for the future needs
    loadNamespaces(ns) {
      return i18Instance.loadNamespaces(ns, callback);
    },
    changeLanguage(lng) {
      return i18Instance.changeLanguage(lng, callback);
    },
  };

  initReactI18next.init(localization.instance);

  await localization.init();
};
